<template>
  <div
    class="payable-list-main-wrapper cbg-white-container theme--light v-card border-card input-container"
  >
    <CCol sm="12">
      <CRow class="m-0 payable-values justify-content-space-bet">
        <CCol sm="2" md="4" class="border-card flex-half-width mb-3 flex-mob-half-width">
          <div class="media">
            <div class="media-img">
              <incomeSVG />
            </div>

            <div class="media-body">
              <h5 class="mt-0 mb-1 font-weight-normal">Revenue</h5>
              <p class="mb-0">{{ revenue | currency }}</p>
            </div>
          </div>
        </CCol>
        <CCol sm="2" md="4" class="border-card flex-half-width mb-3 flex-mob-half-width">
          <div class="media">
            <div class="media-img">
              <incomeSVG />
            </div>

            <div class="media-body">
              <h5 class="mt-0 mb-1 font-weight-normal">Razorpay Charges</h5>
              <p class="mb-0">{{ razorPay | currency }}</p>
            </div>
          </div>
        </CCol>
        <CCol sm="2" class="border-card flex-half-width mb-3 flex-mob-half-width">
          <div class="media">
            <div class="media-img">
              <incomeSVG />
            </div>

            <div class="media-body">
              <h5 class="mt-0 mb-1 font-weight-normal">G S T</h5>
              <p class="mb-0">{{ gst | currency }}</p>
            </div>
          </div>
        </CCol>
      </CRow>
    </CCol>
    <!-- ... end 12 .... -->
    <CCol sm="12">
      <CRow>
        <CCol sm="6" md="3" class="datepicker pos-r">
          <label for class="mr-3 d-block-mob">Date Range</label>
          <datepicker
            ref="datepicker"
            v-model="date"
            :model-config="datePickerConfig"
            is-range
            :masks="{ input: 'DD/MM/YYYY' }"
            @input="onDateChange"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <input
                :value="
                  !!inputValue.start && !!inputValue.end
                    ? inputValue.start + ' - ' + inputValue.end
                    : 'DD/MM/YYYY'
                "
                v-on="inputEvents.start"
                class="form-control position-relative"
                placeholder="DD/MM/YYYY"
              />
              <div
                v-if="!!inputValue.start && !!inputValue.end"
                class="cross-svg"
                @click="resetActiveDate"
              >
                <crossSVG />
              </div>
            </template>
          </datepicker>
          <div class="calendarsvg userinputcalendar pos-a">
            <calendarSVG />
          </div>
        </CCol>
        <CCol sm="6" md="3" class="form-group search-div">
          <label for>Search User</label>
          <div class="col-sm-12 p-0 search-div position-relative">
            <input
              type="text"
              class="form-control"
              placeholder="Search"
              @input="searchEntries"
              v-model="search"
            />
            <!-- <div class="search-svg">
              <searchSVG />
            </div>-->
            <div v-if="search !== ''" class="search-svg position-absolute" @click="clearSearch()">
              <crossSVG />
            </div>
            <!-- <div class="search-svg">
              <crossSVG />
            </div>-->
          </div>
        </CCol>
        <CCol sm="6" md="2">
          <div class="position-relative w-7">
            <label for class="fz-12">Payment Status</label>
            <select name id class="form-control" @change="searchEntries" v-model="status">
              <option value="">All</option>
              <option value="open">Pending</option>
              <option value="paid">Completed</option>
              <option value="void">Cancelled</option>
            </select>
            <span class="drop-icon">
              <i aria-hidden="true" class="v-icon mdi mdi-menu-down theme--light position-absolute"></i>
            </span>
          </div>
        </CCol>
        <CCol sm="6" md="2">
          <div class="position-relative w-7">
            <label for>Payment Type</label>
            <select name id class="form-control" @change="searchEntries" v-model="type">
              <option value>All</option>
              <option value="online">Online</option>
              <option value="offline">Offline</option>
            </select>
            <span class="drop-icon">
              <i aria-hidden="true" class="v-icon mdi mdi-menu-down theme--light position-absolute"></i>
            </span>
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol md="2" sm="6">
          <div class="position-relative w-7">
            <label for>Source</label>
            <select name id class="form-control" @change="searchEntries" v-model="source">
              <option value>All</option>
              <option value="APPOINTMENT">Appointment</option>
              <option value="HOME_VISIT">Home Visit</option>
              <option value="ONLINE_CONSULTATION">Online Consultation</option>
              <option value="SUBSCRIPTION">Doctor Subscription</option>
              <option value="CENTER_SUBSCRIPTION">Center Subscription</option>
              <option value="PAY_PER_USE">Pay Per Use</option>
              <option value="PHARMACY_BOOKING">Pharmacy Booking</option>
              <option value="CANCELLATION_CHARGES">Cancellation Charges</option>
            </select>
            <span class="drop-icon">
              <i aria-hidden="true" class="v-icon mdi mdi-menu-down theme--light position-absolute"></i>
            </span>
          </div>
        </CCol>
        <CCol v-if="permissions.includes('CAN_EXPORT_MASTER')" sm="2">
          <label class="col-sm-12 mb-0 d-none-mob1"></label>
          <v-btn v-if="!loading" class="btn btn-primary" @click="exportCSV">Export CSV</v-btn>
        </CCol>
        <CCol v-if="permissions.includes('CAN_EXPORT_MASTER')" sm="2">
          <label class="col-sm-12 mb-0 d-none-mob1"></label>
          <v-btn v-if="!loading" class="btn btn-primary" @click="exportInvoices">Export Invoices</v-btn>
        </CCol>
      </CRow>
      <!-- <CRow>
       
      </CRow>-->
    </CCol>
    <!-- ... end 12 .... -->
    <CCol sm="12" class="overflow-auto">
      <table class="table userlistTable table-width small-table-width">
        <thead>
          <tr class="table-success">
            <th scope="col">Date</th>
            <th scope="col">Payment From</th>
            <th scope="col">Payment to</th>
            <th scope="col">Source</th>
            <th scope="col">Reference ID</th>
            <th scope="col">Payment Status</th>
            <th scope="col">Appointment Date</th>
            <th scope="col">Total</th>
            <th scope="col">Utility Charges</th>
            <th scope="col">Mode of Payment</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="entry in entries" :key="entry.transaction_id">
            <td>{{ entry.date | date }}</td>
            <td>{{ entry.billed_to_metadata | name }}</td>
            <td>{{ entry.billed_by_metadata | name }}</td>
            <td>{{ entry.meta && entry.meta.type }}</td>
            <td>{{ entry.order_id || "-" }}</td>
            <td>{{ entry.status | transactionStatus }}</td>
            <td v-if="entry.meta && entry.meta.type === 'APPOINTMENT'">
              {{ entry.meta.opd_date | date }}
            </td>
            <td v-else>
              -
            </td>
            <td>&#8377; {{ entry.total }}</td>
            <td>&#8377; {{ entry.charges || 0 }}</td>
            <td>{{ entry.payment | modeOfPayment }}</td>

            <!-- <td class="action-div">
              <div>
                <CDropdown color="link" size="lg" :caret="false">
                  <template #toggler-content>
                    <verticalDotsSVG />
                  </template>
                  <CDropdownItem>View Details</CDropdownItem>
                  <CDropdownItem>Call</CDropdownItem>
                  <CDropdownItem>Chat</CDropdownItem>
                  <CDropdownItem>Email</CDropdownItem>
                </CDropdown>
              </div>
            </td>-->
            <td class="action-div small-table-padding">
                  <div>
                    <CDropdown
                      color="link"
                      size="lg"
                      :caret="false"
                      class="dropdowndocbox dropaddbox"
                    >
                      <template #toggler-content>
                        <verticalDotsSVG />
                      </template>
                      <CDropdownItem @click="viewInvoice(entry.transaction_id, false)"
                        >View Invoice</CDropdownItem
                      >
                      <CDropdownItem v-if="showPlatformInvoice(entry.payment)"  @click="viewInvoice(entry.transaction_id, true)"
                        >View Platform Invoice</CDropdownItem
                      >
                    </CDropdown>
                  </div>
                </td>
          </tr>
        </tbody>
      </table>
    </CCol>
    <pagination
      v-if="!isEmpty"
      class="mx-4 mob-t-center pagination-block"
      :recordPerPage="record_per_page"
      :total="total"
      @changePage="onChangePage"
    />
    <v-dialog
      v-model="invoiceDialog"
      v-if="invoiceDialog"
      width="800"
      content-class="v-dialog-lg"
      scrollable
      persistent
    >
      <pdf-html
        title="Invoice"
        :subject="subject"
        HidePrintButton
        HideDownloadButton
        :identifier="invoiceId"
        @close="closeInvoiceDialog"
      ></pdf-html>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import "@/assets/scss/_accounts.scss";
import dayjs from "dayjs";
import formats from "@/formats.js";
import Datepicker from "v-calendar/lib/components/date-picker.umd";
import { pickSvg } from "@/views/SVG";
import Config from "@/config.js";
const API_URL = `${Config.ACCOUNTS_URL}ds-accounts-be`;

export default {
  components: {
    ...pickSvg("incomeSVG", "searchSVG", "verticalDotsSVG", "crossSVG"),
    Datepicker,
    pagination: () => import("@/views/common/Pagination"),
    PdfHtml: () => import("@/components/PdfHtml"),
  },

  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },

  filters: {
    date(val) {
      if (!val) {
        return "-";
      }
      return dayjs(val).format(formats.date_time_format);
    },
    name(val) {
      if (!val) {
        return "-";
      }
      return `${val.first_name} ${val.last_name}`;
    },
    modeOfPayment: value => {
      const payment = value;
      const modes = payment.map(entry => entry.mode);
      return modes.join(",");
    },
    currency(val) {
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR"
      }).format(val);
    },
    transactionStatus: value => {
      let status = value;
      switch (value) {
        case "void":
          status = "Cancelled";
          break;
        case "draft":
        case "open":
          status = "Pending";
          break;
        case "paid":
          status = "Completed";
          break;
        default:
          status = value;
      }
      return status;
    }
  },
  data: function() {
    return {
      datePickerConfig: {
        start: {
          timeAdjust: "00:00:00"
        },
        end: {
          timeAdjust: "23:59:59"
        }
      },
      revenue: 0,
      invoiceDialog: false,
      razorPay: 0,
      subject: "",
      invoiceId: "",
      gst: 0,
      income: 0,
      // filters
      search: "",
      startDate: "",
      endDate: "",
      date: { start: "", end: "" },
      type: "", // all, online, offline, gst, pg
      status: "", // open, paid, void,
      source: "", // APPOINTMENT, HOME_VISIT, ...
      // pagination
      limit: 10,
      offset: 0,
      page: 1,
      total: 0,
      // data
      entries: [],
      // ui
      loading: false,
      isEmpty: false,
      record_per_page: 10,
      currentPage: 1,
      params:{}
    };
  },

  mounted() {
    this.getDashboard();
    this.searchEntries();
  },
  methods: {
    clearSearch() {
      this.currentPage = 1
      this.search = "";
      this.searchEntries();
    },
    showPlatformInvoice(val){
      let temp = false;
        val.map(item => {
        if(item.mode == 'Online PG'){
          temp = true;
           return
        }
       })
       return temp
    },
    viewInvoice(transaction_id, platformInvoice){
      this.invoiceId = transaction_id
      if(platformInvoice) this.subject = 'platformInvoice'
      else this.subject = 'invoiceDr'
      this.invoiceDialog = true
    },
    closeInvoiceDialog() {
      this.invoiceDialog = false;
      this.invoiceId = "";
    },
    resetActiveDate() {
      this.currentPage = 1
      this.date = { start: "", end: "" };
      this.startDate = "";
      this.endDate = "";
      this.searchEntries();
    },
    onChangePage(page) {
      // const { currentPage } = page;
      // this.offset = (currentPage - 1) * this.limit;
      this.params = {};
      this.currentPage = page.currentPage;
      this.searchEntries();
    },
    onTypeChange(value) {
      this.currentPage = 1
      this.type = value;
      this.searchEntries();
    },
    onLimitChange(e) {
      this.limit = parseInt(e.target.value, 10);
      this.searchEntries();
    },
    onDateChange(date) {
      this.currentPage = 1
      this.startDate = dayjs(date.start).format("YYYY-MM-DD");
      this.endDate = dayjs(date.end)
        .add(1, "day")
        .format("YYYY-MM-DD");
      this.onChangePage({currentPage: 1});
    },
    onClearDate() {
      this.date = "";
      this.startDate = null;
      this.endDate = null;
      this.searchEntries();
    },
    getSearchParams() {
      this.params = {
        limit: this.limit,
        offset: this.offset,
        page: this.currentPage,
        record_per_page: this.record_per_page
      }
      if (this.startDate && this.endDate) {
        this.params.start = this.startDate;
        this.params.end = this.endDate;
      }
      if (this.search.length > 0) {
        this.params.global = this.search;
      }
      if (this.status) {
        this.params.status = this.status;
      }
      if (this.type) {
        this.params.view = this.type;
      }
      if (this.source) {
        this.params.source = this.source;
      }
    },
    searchEntries() {
      // this.isEmpty = true;
      this.loading = true;
      this.entries = [];
      // if (
      //   this.type !== "income" &&
      //   this.type !== "receivables" &&
      //   this.type !== "all"
      // ) {
      //   this.loading = false;
      //   return;
      // }
      this.params = {
        limit: this.limit,
        offset: this.offset,
        page: this.currentPage,
        record_per_page: this.record_per_page
      }
      if (this.startDate && this.endDate) {
        this.params.start_date = this.startDate;
        this.params.end_date = this.endDate;
      }
      if (this.search.length > 0) {
        this.params.search = this.search;
      }
      if (this.status) {
        this.params.status = this.status;
      }
      if (this.type) {
        this.params.view = this.type;
      }
      if (this.source) {
        this.params.source = this.source;
      }
      this.$http
        .post(`${API_URL}/v2/transaction/listing_admin`,this.params)
        .then(
          res => {
            this.loading = false;
            // this.limit = 10;
            // this.total = Number(response.headers.get("query-count"));
            // this.entries = response.data.data;
            // turning off invoice export as it needs discussion wrt implementation
            // if (fetchInvoice) {
            //   this.fetchInvoices();
            // }
            
            if (res && res.data && res.data.data && res.data.data.list.length) {
              this.entries = res.data.data.list
              this.isEmpty = false;
              this.currentPage = res.data.data.page;
              this.total = res.data.data.count;
            } else {
              this.entries = [];
              this.currentPage = res.data.data.page;
              this.total = res.data.data.count;
            }
          },
          err => {
            this.loading = false;
            this.entries = [];
            console.log(err);
          }
        );
    },
    exportInvoices() {
      this.type = "online";
      this.status = "paid";
      this.limit = 50;
      this.searchEntries(true);
    },
    fetchInvoices() {
      this.loading = true;
      this.entries.forEach((entry) => {
        if (entry.meta && entry.meta.type === 'SUBSCRIPTION') {
          const url = `${Config.BASE_URL}api/v2/pdf/invoice/doctor/${entry.transaction_id}?to_download=true`;
          window.open(url);
        } else {
          const url = `${Config.BASE_URL}api/v2/pdf/invoice/platform/${entry.transaction_id}?to_download=true`;
          window.open(url);
        }
      });
      this.loading = false;
    },
    exportCSV() {
      this.params = {
        limit: this.limit,
        offset: this.offset,
        page: this.currentPage,
        record_per_page: this.record_per_page
      }
      if (this.startDate && this.endDate) {
        this.params.start_date = this.startDate;
        this.params.end_date = this.endDate;
      }
      if (this.search.length > 0) {
        this.params.search = this.search;
      }
      if (this.status) {
        this.params.status = this.status;
      }
      if (this.type) {
        this.params.view = this.type;
      }
      if (this.source) {
        this.params.source = this.source;
      }
      this.$http
        .post(`${API_URL}/v2/transaction/listing/export`, this.params)
        .then(response => {
          const uriContent =
            "data:text/csv;charset=utf-8," + encodeURIComponent(response.body.data.csv);
          const date = dayjs(new Date()).format(formats.date_format);
          const myWindow = window.open(uriContent, `${date}_accounts.csv`);
          myWindow.focus();
        });
    },
    getDashboard() {
      this.$http.get(`${API_URL}/v2/transaction/dashboard`).then(
        response => {
          const { status, data } = response.data;
          if (status) {
            const stats = {
              revenue: 0,
              razorPay: 0,
              gst: 0,
              video: 0,
              income: 0
            };
            for (const entry of data) {
              if (
                (entry._id === "paid" || entry._id === "void") &&
                entry.charges > 0
              ) {
                stats.revenue += entry.charges;
              }
            }
            stats.razorPay = stats.revenue * 0.02;
            stats.gst = stats.revenue * 0.18;
            stats.income = stats.revenue - stats.razorPay - stats.gst;
            this.revenue = stats.revenue;
            this.razorPay = stats.razorPay;
            this.gst = stats.gst;
            this.income = stats.income;
          }
        },
        err => {
          console.log(err);
        }
      );
    }
  }
};
</script>